import Gobalstore from "../index";
export const actions = {
  loginAndSaveToken: function (localStore, user) {
    var that = this;
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "POST",
      url: "/admin/login",
      data: user,
    })
      .then((response) => {
        localStore.commit("setToken", response.data["access_Token"]);
        localStorage.setItem("access_Token", response.data["access_Token"]);
        localStorage.setItem("refresh_token", response.data["refresh_token"]);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        Gobalstore.commit("LoadingOverlay", false);
        that.router.push({ path: "/main" });
        localStore.dispatch("getNavigationMenu", response.data.user.emp_id);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  logout: function (localStore) {
    localStore.commit("setToken", "");
    localStorage.removeItem("access_Token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");

    var that = this;
    that.router.push({ path: "/login" });

  },

  getNavigationMenu: function (localStore, userid) {
    var that = this;
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/menus/${userid}`,
    })
      .then(function (response) {
        let data = [...response.data].sort(
          (a, b) => parseFloat(a.menu_order) - parseFloat(b.menu_order)
        );
        localStore.commit("setNavigation", data);
        localStorage.setItem("nav-menu", JSON.stringify(data));
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
  changePassword: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    var that = this;
    return this.axios({
      method: "PATCH",
      url: "/admin/guarded/main/user/password",
      data: payload.data,
      headers: payload.headers
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        return res;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },
};
